export default function PointsDom() {
  return (
    // 在TTD平台上追踪 add to cart事件 ：加入购物车成功后触发统计事件
    <img
      height="1"
      width="1"
      style={{ borderStyle: 'none' }}
      alt=""
      src="https://insight.adsrvr.org/track/pxl/?adv=6j0izqh&ct=0:amhzvs2&fmt=3"
    />
  );
}
